import React from 'react';
import { maintenance } from '../../images/btnIcons';

const SystemDown = () => {
    return (
        <div className='system-dwn-wrapper'>
            <div className='sytem-dwn-cntnr'>
                <div className='sytem-dwn-logo'>
                    <img src={maintenance} alt='MAX_LOGO' />
                </div>
                <div className='sytem-dwn-text'>
                    <h3>System is down</h3>
                    <p>Please try again after some time</p>
                </div>
            </div>
        </div>
    );
};

export default SystemDown;